// @ts-expect-error untype dependency
import growthImageUrl from 'bender-url!marketplace-assets-base/img/templates-homepage/growth-analytics-icon.svg';
// @ts-expect-error untype dependencys
import homepageImageUrl from 'bender-url!marketplace-assets-base/img/templates-homepage/homepage-icon.svg';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Big } from 'foundations-components/transitional/components/Big';
import { Image } from 'foundations-components/transitional/components/Image';
import { Section } from 'foundations-components/transitional/components/Section';
import { getAssetBusinessTypeTranslationKey } from 'marketplace-ui-assets-core/utils/i18n';
import Carousel from 'marketplace-ui-common/components/Carousel';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import StorefrontSection from 'marketplace-ui-common/storefront/components/StorefrontSection';
import { Fragment, useMemo } from 'react';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import AssetBusinessTypeUrls from '../../constants/urls/AssetBusinessType';
import { useUsedBusinessTypeValues } from '../../hooks/useUsedBusinessTypeValues';
import ThemeCollectionsCardGrid from '../../storefront/components/ThemeCollectionsCardGrid';
import { getAllThemeCollectionsRoute, getThemesStorefrontRoute } from '../../utils/urls';
import { AudioInputOutputIcon } from 'foundations-assets/icons/components/AudioInputOutputIcon';
import { BulbIcon } from 'foundations-assets/icons/components/BulbIcon';
import { CapIcon } from 'foundations-assets/icons/components/CapIcon';
import { CartIcon } from 'foundations-assets/icons/components/CartIcon';
import { ContactDuplicateIcon } from 'foundations-assets/icons/components/ContactDuplicateIcon';
import { DateIcon } from 'foundations-assets/icons/components/DateIcon';
import { DesktopIcon } from 'foundations-assets/icons/components/DesktopIcon';
import { GiftIcon } from 'foundations-assets/icons/components/GiftIcon';
import { KeyIcon } from 'foundations-assets/icons/components/KeyIcon';
import { LanguageIcon } from 'foundations-assets/icons/components/LanguageIcon';
import { ListsIcon } from 'foundations-assets/icons/components/ListsIcon';
import { SalesQuoteIcon } from 'foundations-assets/icons/components/SalesQuoteIcon';
import { SocialHeartIcon } from 'foundations-assets/icons/components/SocialHeartIcon';
import { StylesIcon } from 'foundations-assets/icons/components/StylesIcon';
import { TagIcon } from 'foundations-assets/icons/components/TagIcon';
import { ThemeIcon } from 'foundations-assets/icons/components/ThemeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ASSET_BUSINESS_TYPE_ICON_MAP = {
  ART_ENTERTAINMENT: StylesIcon,
  CUSTOMER_SERVICE: AudioInputOutputIcon,
  ECOMMERCE: GiftIcon,
  EVENT_MANAGEMENT: DateIcon,
  FINANCIAL_SERVICES: SalesQuoteIcon,
  FOOD_BEVERAGE: TagIcon,
  HEALTH_BEAUTY: SocialHeartIcon,
  HR_RECRUITING: ListsIcon,
  MARKETING: BulbIcon,
  NONPROFIT_EDUCATION: CapIcon,
  PROFESSIONAL_SERVICES: ContactDuplicateIcon,
  REAL_ESTATE: KeyIcon,
  RETAIL: CartIcon,
  SMALL_BUSINESS: ThemeIcon,
  TECHNOLOGY: DesktopIcon,
  TRAVEL_HOSPITALITY: LanguageIcon
};
function BusinessTypeIcon({
  type
}) {
  const Icon = ASSET_BUSINESS_TYPE_ICON_MAP[type];
  return /*#__PURE__*/_jsx(Icon, {
    size: "800"
  });
}
function ThemesInnerSection({
  children
}) {
  return /*#__PURE__*/_jsx(View, {
    marginInline: "1100",
    paddingBlockStart: "1300",
    paddingInline: "1000",
    as: "div",
    children: children
  });
}
export default function ThemesSection({
  onTrackInteraction
}) {
  const businessTypeValues = useUsedBusinessTypeValues();
  const {
    direction,
    maxCardsPerPage,
    width
  } = useResponsiveProps({
    direction: {
      [ScreenSizes.XS]: 'column',
      [ScreenSizes.MD]: 'row'
    },
    maxCardsPerPage: {
      [ScreenSizes.SM]: 2,
      [ScreenSizes.MD]: 3,
      [ScreenSizes.LG]: 5
    },
    width: {
      [ScreenSizes.XS]: undefined,
      [ScreenSizes.MD]: '50%'
    }
  });
  const businessTypeCards = useMemo(() => businessTypeValues.map((businessType, index) => /*#__PURE__*/_jsx(RouterButton, {
    to: getThemesStorefrontRoute(AssetBusinessTypeUrls[businessType]),
    use: "unstyled",
    height: "85px",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(BusinessTypeIcon, {
        type: businessType
      }), /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        marginBlockStart: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getAssetBusinessTypeTranslationKey(businessType)
        })
      })]
    })
  }, index)), [businessTypeValues]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ThemesInnerSection, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          color: "text-core-default",
          role: "heading",
          typography: "heading-600",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.themes.title"
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: direction,
          marginInlineEnd: "0",
          padding: "1000",
          justifyContent: "center",
          children: [/*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            flexDirection: "column",
            marginInlineEnd: "400",
            inlineSize: width,
            children: [/*#__PURE__*/_jsx(Image, {
              blockSize: "200px",
              src: homepageImageUrl,
              role: "presentation"
            }), /*#__PURE__*/_jsx(Text, {
              as: "h3",
              textAlign: "center",
              typography: "heading-400",
              marginBlockEnd: "400",
              role: "heading",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.templates.themes.simpleUseTitle"
              })
            }), /*#__PURE__*/_jsx(Text, {
              textAlign: "center",
              children: /*#__PURE__*/_jsx(Big, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.templates.themes.simpleUseSubtitle"
                })
              })
            })]
          }), /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            flexDirection: "column",
            marginInlineStart: "400",
            inlineSize: width,
            children: [/*#__PURE__*/_jsx(Image, {
              blockSize: "200px",
              src: growthImageUrl,
              role: "presentation"
            }), /*#__PURE__*/_jsx(Text, {
              as: "h3",
              textAlign: "center",
              typography: "heading-400",
              marginBlockEnd: "400",
              role: "heading",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.templates.themes.analyticsTitle"
              })
            }), /*#__PURE__*/_jsx(Text, {
              textAlign: "center",
              children: /*#__PURE__*/_jsx(Big, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.templates.themes.analyticsSubtitle"
                })
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(RouterButton, {
          onClick: () => {
            onTrackInteraction('click themes storefront link');
          },
          to: getThemesStorefrontRoute(),
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.themes.button"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(ThemesInnerSection, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-400",
        marginBlockEnd: "900",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.themes.browseByIndustryTitle"
        })
      }), /*#__PURE__*/_jsx(Carousel, {
        cards: businessTypeCards,
        gutterSize: 10,
        maxCardsPerPage: maxCardsPerPage,
        showPagination: false
      })]
    }), /*#__PURE__*/_jsx(ThemesInnerSection, {
      children: /*#__PURE__*/_jsx(StorefrontSection, {
        primaryGridSize: 9,
        subtitle: /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "0",
          as: "p",
          children: /*#__PURE__*/_jsx(Big, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.templates.themes.themeCollectionsSubtitle"
            })
          })
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.themes.themeCollectionsTitle"
        }),
        titleControls: /*#__PURE__*/_jsx(RouterLink, {
          onClick: () => onTrackInteraction('all collections link'),
          to: getAllThemeCollectionsRoute(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.themes.collectionsLink"
          })
        }),
        titleControlsMobile: "md",
        children: /*#__PURE__*/_jsx(Section, {
          use: "island",
          children: /*#__PURE__*/_jsx(ThemeCollectionsCardGrid, {})
        })
      })
    })]
  });
}